@if (customPrivacyPolicy) {
  <div class="privacy-policy-custom">
    <div [innerHTML]="customPrivacyPolicy"></div>
  </div>
} @else {
  <div class="checkbox">
    <label class="terms-of-service">
      @if (!editMode) {
        <input
            [disabled]="!!editMode"
            [formControl]="formControl"
            type="checkbox"
            class="required"
            id="member_form_tos">
        <span class="checkbox-material"><span class="check"></span></span>
        <span class="privacy-policy-link-prefix">{{ 'generic.tos_accept_link_prefix' | translate }} </span>
      } @else {
        <span class="privacy-policy-link-prefix">{{ 'generic.tos_notice_link_prefix' | translate }} </span>
      }
    </label><a class="privacy-policy-link" target="_blank"
               [href]="privacyPolicyHref">{{ 'generic.tos_notice_link' | translate }}</a>
  </div>
  <app-input-errors [translationKey]="'errors.tos'"
                    [errorsForField]="formErrors"/>
}
